// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from "react"
import "./ErrorBoundary.scss"

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h1 className="error-boundary__title">Whoah!</h1>
          <p className="error-boundary__message">
            The page encountered an error. If you ask me it is probably the
            fault of the backend dev.
          </p>
          <button
            className="error-boundary__button"
            onClick={() => window.location.reload()}
          >
            Try Again
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
